/**
 * RBAC resource and action names — mirrors tap-api src/constants/permissions.ts
 * EXACTLY. Permission checks compose `${resource}:${action}`. If tap-api changes,
 * this file must change in lockstep.
 */
export const RESOURCE = {
  USER: 'user',
  USERS: 'users',
  ROLE: 'role',
  TENANT: 'tenant',
  PARTNER: 'partner',
  ASSET: 'asset',
  GATEWAY: 'gateway',
  TAG: 'tag',
  ALARM: 'alarm',
  DASHBOARD: 'dashboard',
  REPORT: 'report',
  CONNECTOR: 'connector',
  /** Authored, parameterized queries behind `query` bindings. */
  SAVED_QUERY: 'saved_query',
  SETTINGS: 'settings',
  AUDIT: 'audit',
} as const

export type Resource = (typeof RESOURCE)[keyof typeof RESOURCE]

export const ACTION = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  MANAGE: 'manage', // superpower: implies all other actions on the resource
} as const

export type Action = (typeof ACTION)[keyof typeof ACTION]
